import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  padding: 1.25rem 2rem;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
`;

const HeaderContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Logo = styled.a`
  color: #3a5cf7;
  font-size: 1.625rem;
  font-weight: 800;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  letter-spacing: -0.02em;
  
  &:hover {
    transform: scale(1.05);
    opacity: 0.9;
  }
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 2rem;
  
  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

const NavLink = styled.a`
  color: #374151;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
  transition: color 0.3s ease;
  
  &:hover {
    color: #3a5cf7;
  }
`;

const CTAButton = styled.a`
  background: linear-gradient(135deg, #3a5cf7 0%, #2d4ae8 100%);
  color: white;
  border: none;
  padding: 0.875rem 1.75rem;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.9375rem;
  box-shadow: 0 4px 6px -1px rgba(58, 92, 247, 0.3);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }
  
  &:hover {
    background: linear-gradient(135deg, #2d4ae8 0%, #1e3a8a 100%);
    transform: translateY(-3px);
    box-shadow: 0 12px 24px -4px rgba(58, 92, 247, 0.4);
    
    &::before {
      left: 100%;
    }
  }
`;

function Header({ onGetStartedClick }) {
  const handleGetStarted = (e) => {
    e.preventDefault();
    if (onGetStartedClick) {
      onGetStartedClick();
    } else {
      // Fallback: scroll to upload section
      const uploadSection = document.getElementById('upload-section');
      if (uploadSection) {
        uploadSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <HeaderContainer>
      <HeaderContent>
        <Logo href="/">Rhinovate</Logo>
        
        <Nav>
          <CTAButton href="#" onClick={handleGetStarted}>Get Started</CTAButton>
        </Nav>
      </HeaderContent>
    </HeaderContainer>
  );
}

export default Header;
